const dividerPalette = (tokens) => {
    return {
        border: {
            width: tokens.dividerBorderWidth,
            color: tokens.dividerColor
        }
    };
};
export default dividerPalette;
//# sourceMappingURL=divider.js.map